module.exports = __webpack_public_path__ + "img/cai-hui.6fb4bdec.png";